import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

export default function MediosDePago() {
  return (
    <Container className="my-5">
      <Row className="justify-content-center">
        <Col xs={12} md={10}>
          <h4 className="mt-4" style={{
                    color: "#7AC70C",
                    fontWeight: "bold",
                    fontSize: "1.4rem",
                  }}>VIII. MEDIOS DE PAGO</h4>
          <br></br>          
          <p>
            El pago de los servicios solicitados las órdenes solicitadas a través de las Plataformas se realizarán a través del método de pago registrado y seleccionado por el Usuario.
          </p>

          <ol style={{ listStyleType: 'lower-alpha', paddingLeft: '20px' }}>
            <li>
              <p>
                <strong>TARJETA CRÉDITO O DÉBITO</strong>
              </p>
              <p>
                El Usuario podrá realizar el pago con tarjetas de crédito o débito emitidas por entidades financieras autorizadas. Al seleccionar esta opción, el Usuario deberá proporcionar los datos requeridos para procesar la transacción de manera segura a través de la pasarela de pago habilitada en la Plataforma.
              </p>
              <p>
                El procesamiento del pago está sujeto a la validación y autorización por parte de la entidad financiera emisora de la tarjeta y de la pasarela de pago. En caso de que la transacción sea rechazada por cualquier motivo, el pedido no será confirmado, y el Usuario deberá seleccionar otro método de pago disponible.
              </p>
              <p>
                El uso del Hub de Pagos estará sujeto a los términos establecidos en su Política de Privacidad, la cual podrá ser consultada en la página web y directamente en el hub.
              </p>
            </li>
            <li>
              <p>
                <strong>BILLETERA</strong>
              </p>
              <p>
                Medio de pago recargable a través del cual el Usuario realizará el pago de los Servicios ofrecidos por Parking.
              </p>
              <ul style={{ paddingLeft: '20px' }}>
                <li>
                  <p>
                    La carga o recarga mínima en la Billetera es de veinte mil pesos colombianos ($20.000 COP)
                  </p>
                </li>
                <li>
                  <p>
                    Para realizar cualquier pago por medio de la Billetera, los Usuarios deberán contar con saldo suficiente con el fin de evitar inconvenientes al momento de pagar el servicio.
                  </p>
                </li>
                <li>
                  <p>
                    La Billetera se podrá recargará por medio de tarjeta crédito, tarjeta débito y PSE.
                  </p>
                </li>
                <li>
                  <p>
                    Las recargas de la Billetera deberán realizarse por el Usuario empleando cualquier medio de pago habilitado en la plataforma.
                  </p>
                </li>
                <li>
                  <p>
                    Por cada recarga de la Billetera el Usuario recibirá en el correo electrónico registrado un comprobante que contendrá la información relacionada con: (i) el monto pagado, (ii) el saldo disponible, y (iii) la fecha de vencimiento del saldo disponible que será de un (1) año desde el momento en que se realizó la compra.
                  </p>
                </li>
                <li>
                  <p>
                    Cuando el Usuario realice la recarga de la Billetera, Parking emitirá un comprobante de venta por el valor total. En la medida que el Usuario consuma su saldo, se emitirán las facturas correspondientes al pago que se efectúe.
                  </p>
                </li>
                <li>
                  <p>
                    Las recargas no son objeto de devolución y se están sujetas a la aplicación de su vencimiento de acuerdo con lo dispuesto en estos T&C.
                  </p>
                </li>
                <li>
                  <p>
                    Las recargas solamente podrán ser utilizadas en la manera descrita en estos T&C.
                  </p>
                </li>
                <li>
                  <p>
                    Los saldos de la Billetera tendrán un (1) año de vigencia, contado a partir del momento en que el Usuario haya realizado cada una de las recargas, plazo dentro del cual deberá utilizarse el saldo o de lo contrario se perderá. Lo anterior podrá ser modificado en cualquier momento, situación que será informada al Usuario a través del correo electrónico registrado o cualquier otro medio que Parking disponga para el efecto.
                  </p>
                </li>
                <li>
                  <p>
                    El Usuario podrá consultar sus saldos y fechas de vencimiento a través de la App, o a través de los medios de contacto dispuestos para atender al cliente.
                  </p>
                </li>
                <li>
                  <p>
                    En caso que Parking requiera hacer la devolución de saldos al Usuario con ocasión de errores en el cobro u otras circunstancias, se realizará mediante cupones o bonos de parqueo.
                  </p>
                </li>
                <li>
                  <p>
                    En el caso en el que Parking verifique que el método de pago seleccionado por el Usuario al solicitar órdenes a través de la Plataforma está vencido, no es válido, no cuenta con fondos suficientes, o cualquier otra situación que no permita que el Usuario realice el pago de la orden, y por lo tanto el pago no sea exitoso, el Usuario acepta que Parking puede denegar el acceso a la App o inhabilitar los servicios hasta que los pagos estén al día.
                  </p>
                </li>
                <li>
                  <p>
                    El Usuario acepta la política de tratamiento de datos que podrá ser consultada a través de las Plataformas.
                  </p>
                </li>
              </ul>
            </li>
          </ol>
        </Col>
      </Row>
    </Container>
  );
}